export enum FrontNotificationType {
  DEBUG = 'info',
  SUCCESS = 'success',
  WARN = 'warning',
  ERROR = 'error',
}
export interface FrontNotification<T = unknown> {
  type: FrontNotificationType
  id?: string
  date?: number
  title: string
  message: string
  extra?: T
  action?: {
    title: string
    callback: () => Promise<T>
    closeOnCallback: boolean | undefined
  }
  timeToStay?: number
}
